module.exports = __webpack_public_path__ + "static/media/marvelous_06.e3a5741a.jpg";